import type { CreateUserDto } from "@/dtos/CreateUserDto";
import type { LoginDto } from "@/dtos/LoginDto";
import type { RecoveryPasswordDto } from "@/dtos/RecoveryPasswordDto";
import type { ResetPasswordDto } from "@/dtos/ResetPasswordDto";
import type { VerifyEmailDto } from "@/dtos/VerifyEmailDto";
import api from "@/services/api";
import { useMutation } from "@tanstack/react-query";

export const useRegister = () => {
  return useMutation({
    mutationKey: ["register"],
    mutationFn: async (createUserDto: CreateUserDto) => {
      const response = await api.post("/accounts/register", createUserDto);

      return response.data;
    },
  });
};

export const useLogin = () => {
  return useMutation({
    mutationKey: ["login"],
    mutationFn: async (loginDto: LoginDto) => {
      const response = await api.post("/accounts/login", loginDto);

      return response.data;
    },
  });
};

export const useVerifyEmail = () => {
  return useMutation({
    mutationKey: ["verifyEmail"],
    mutationFn: async (verifyEmailDto: VerifyEmailDto) => {
      const response = await api.get("/accounts/verify-email", {
        params: verifyEmailDto,
      });

      return response.data;
    },
  });
};

export const useRecoveryPassword = () => {
  return useMutation({
    mutationKey: ["recoveryPassword"],
    mutationFn: async (recoveryPasswordDto: RecoveryPasswordDto) => {
      const response = await api.post(
        "/accounts/forgot-password",
        recoveryPasswordDto
      );

      return response.data;
    },
  });
};

export const useResetPassword = () => {
  return useMutation({
    mutationKey: ["resetPassword"],
    mutationFn: async (resetPasswordDto: ResetPasswordDto) => {
      const response = await api.post(
        "/accounts/reset-password",
        resetPasswordDto
      );

      return response.data;
    },
  });
};
